import { Switch, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SelectToPayToggle = ({ isSelectMode, onChange }) => {
	const { t } = useTranslation();

	return (
		<div className="select-to-pay-toggle">
			<FormControlLabel
				control={
					<Switch
						checked={isSelectMode}
						onChange={onChange}
						color="primary"
						data-testid="select-to-pay-toggle-switch"
					/>
				}
				label={<span className="select-to-pay-toggle__label">{t('Bookings.Filter.SelectToPay')}</span>}
				labelPlacement="end"
			/>
		</div>
	);
};

export default SelectToPayToggle;
